<template>
  <div class="page-block-item">
    <div class="title-wrap">
      <div class="title" v-html="title"></div>
      <div class="right-slot">
        <slot name="right"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    props: {
      titleType: String,
      titleName: String,
    },
    computed: {
      title() {
        if (this.titleName) {
          return this.titleName;
        }
        if (this.titleType) {
          switch (this.titleType) {
            case "basic-config":
              return "基本配置";
          }
        }

        return "条件搜索";
      },
    },
    methods: {},
  };
</script>
<style lang="less" scoped>
  .page-block-item {
    .title-wrap {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px dashed #e6e6e6;
      margin-bottom: 10px;

      .title {
        display: flex;
        flex-grow: 0;
        align-items: center;
        padding-left: 10px;
        border-left: 4px solid #619cff;
        color: #210e1e;
        font-size: 16px;
        line-height: 1.2;
      }
      .right-slot {
        margin-left: 40px;
      }
    }
  }
</style>
